import { Entity } from '@core/entities/entity'
import { plainToInstance, Type } from 'class-transformer'
import { ImageDuplicatedIn, IImageDuplicate } from '@core/entities/ImageWarning'

export class ImageDuplicate extends Entity<IImageDuplicate> {
  questionId: string

  mediaKey: string

  downloadUrl: string

  @Type(() => ImageDuplicatedIn)
  duplicatedIn: Array<ImageDuplicatedIn>

  public static new(payload: unknown): ImageDuplicate {
    const entity = plainToInstance(ImageDuplicate, payload)

    return entity
  }
}
